import { Grid } from '@material-ui/core';
import React from 'react';
import { styles } from './item-list-styles';
import { useTranslation } from 'react-i18next';
import TransactionSaved from '../../action-window/media/transaction_saved.svg';

const TransactionVoided: React.FC = (): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();

  return (
    <Grid
      container
      direction='column'
      className={`fullHeight ${classes.transactionVoidedContainer}`}
      data-testid={'transaction-voided-message'}
    >
      <Grid
        item
        className={classes.transactionVoidedText}
        data-testid={'transaction-voided-message-text'}
      >
        {t('TransactionVoided')}
      </Grid>
      <Grid item>
        <Grid container className={classes.transactionVoidedImageContainer}>
          <img src={TransactionSaved} alt='TransactionSavedIcon' className={classes.icon} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TransactionVoided;
